export const generateTemporaryUserActivationURL = (token: string) => {
  const baseUrl = window.location.origin;
  const params = new URLSearchParams({
    token,
  });
  return new URL('/activate-user?' + params.toString(), baseUrl).toString();
};
